module.exports = __webpack_public_path__ + "static/media/jochenBuling.f92926e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/jochenBuling.jpg
// module id = 1570
// module chunks = 1